import { render } from "./Camera.vue?vue&type=template&id=7ab1151c&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"

import "./Camera.vue?vue&type=style&index=0&id=7ab1151c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\vue.js-3\\service-provider-project\\service-provider\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab1151c"]])

export default __exports__